<script setup lang="ts">
import BaseWidget from '../dashboard/BaseWidget.vue';
import VueApexCharts from 'vue3-apexcharts';

// PROPS
const props = defineProps<{
  type: string;
  data: any;
  chartOptions: any;
  title: string;
}>();
</script>
<template>
  <div class="bar-chart">
    <base-widget>
      <template v-slot:title>
        <div>{{ props.title }}</div>
      </template>
      <template v-slot:body>
        <VueApexCharts :type="props.type" :options="props.chartOptions" :series="props.data" height="300" />
      </template>
    </base-widget>
  </div>
</template>
<style lang="scss">
.bar-chart {
  .title {
    color: $color-primary-darken;
  }
}
</style>
